<template>
  <ContentWrapper>
    <div class="content-heading">
      <div>1:1 문의관리</div>
      <!-- Breadcrumb right aligned-->
      <ol class="breadcrumb ml-auto">
        <li class="breadcrumb-item">
          <a href="#">Home</a>
        </li>
        <li class="breadcrumb-item">
          고객센터관리
        </li>
        <li class="breadcrumb-item active">
          <a href="/notice/PersonalList">1:1문의관리</a>
        </li>
      </ol>
    </div>
    <!-- 검색  -->
    <div class="card card-default" v-show="data.params.mode=='list'">
      <div class="card-body">
        <div class="form-row align-items-center">
          <!-- 기간검색 -->
          <SchDateRange label="기간" :data="data" @search="search" @reset="reset" />
          <!-- 분류 -->
          <div class="form-group no-margin row  mr-2">
            <div class="col-auto">
              <label class="col-form-label">분류</label>
            </div>
            <div class="col-auto">
                <b-form-select :options="searchOptionsAll" v-model="OptionsTextAll" name="CatKind" class="custom-select custom-select-sm"></b-form-select>
            </div>
            <div class="col-auto">
                 <b-btn class="btn btn-xs btn-outline-info mr-2 mt-1" variant="outline-primary" style="width:100px;" @click="popupShowAddCat = true;" >분류 추가</b-btn>
            </div>
          </div>
          <!-- 답변상태 -->
          <!-- <div class="form-group no-margin row ml-2">
            <div class="col-auto">
              <label class="col-form-label">답변 상태</label>
            </div>
            <div class="col-auto">
                <b-form-select :options="searchOptionsAns" v-model="OptionsTextAns" @change="ShowAnswer()" name="CatKind" class="custom-select custom-select-sm"></b-form-select>
            </div>
          </div> -->
          <!-- 항목 검색 -->
          <sch-text label="검색어" :data="data" @search="search" @reset="reset"/>
        </div>
      </div>
    </div>
    <!-- // 검색 -->

    <!-- 목록 -->
    <div v-show="data.params.mode=='list'" class="card card-default">
      <div class="card-header mt-2">
        <span class="text-bold h4">목록</span>
        <ShowCounter label="Show" :data="data" @search="search" class="ml-1 mt-2 mb-0" />
      </div>
      <div class="card-body">
         <table class="table table-striped table-bordered table-hover">
          <thead>
          <tr>
            <td style="text-align:center">No</td>
            <td style="text-align:center">분류</td>
            <td style="text-align:center" @click="localSort.sort('title')">제목<em class="fa-2s mr-2 fas fa-sort"></em></td>
            <td style="text-align:center" @click="localSort.sort('answer')">답변상태<em class="fa-2s mr-2 fas fa-sort"></em></td>
            <td style="text-align:center" @click="localSort.sort('regId')">등록자ID<em class="fa-2s mr-2 fas fa-sort"></em></td>
            <td style="text-align:center" @click="localSort.sort('regDt')">등록일시<em class="fa-2s mr-2 fas fa-sort"></em></td>
          </tr>
          </thead>

          <tbody>
          <tr v-show="data.count==0" class="text-center"><td colspan="9">No matching records</td> </tr>
          <tr v-show="data.count!=0" v-for="(item, index) in data.list" :key="index" > <!--  @click.prevent="edit(item.seq);" -->
            <td class="align-middle text-center" @click="edit(item.seq)">{{data.params.limit*(data.params.page-1) + index+1}}</td>
            <td class="align-middle text-center" @click="edit(item.seq)">
              <b-form-select :options="searchOptions" :value="(item.boardCatSeq)" class="not-select custom-select custom-select-sm" style="width:max-content"></b-form-select>
            </td>
            <td class="align-middle text-center" @click="edit(item.seq)">{{item.title}}</td>
            <td class="align-middle text-center" @click="edit(item.seq)">{{!item.answer ? '대기' : '완료'}}</td>
            <td class="align-middle text-center" @click="edit(item.seq)">{{item.maskedRegId}}</td>
            <td class="align-middle text-center" @click="edit(item.seq)">{{item.regDt}}</td>
          </tr>
          </tbody>
        </table>
      </div>
      <div class="card-footer">
        <div class="d-flex">
          <!--paging component-->
          <Pagenation :data="data" @next="dataAction.next(search)" @prev="dataAction.prev(search)" @first="dataAction.first(search)" @last="dataAction.last(search)" :key="data.params.page"/>
        </div>
      </div>
    </div>
    <!-- // 목록 -->

    <!-- 상세 -->
    <div v-show="data.params.mode=='detail'" class="card card-default book-list">
      <div class="card-body" style="background-color:#fff;">
        <table class="table table-bordered table-hover">
          <colgroup>
                <col width="12%" class="bg-lightdark" />
                <col width="38%" />
                <col width="12%" class="bg-lightdark" />
                <col width="38%" />
            </colgroup>
          <tbody>
              <tr>
                  <td class="align-middle text-center">분류</td>
                  <td class="align-middle">
                       <b-form-select :options="searchOptions" v-model="data.row.boardCatSeq" class="not-select custom-select custom-select-sm" style="width:max-content"></b-form-select>
                  </td>
                  <td class="align-middle text-center">답변여부</td>
                  <td class="align-middle" colspan="3">{{!data.row.answer ? '대기' : '완료'}}</td>
              </tr>
              <tr>
                  <td class="align-middle text-center">제목</td>
                  <td class="align-middle" colspan="3">
                      {{data.row.title}}
                  </td>
              </tr>
              <tr>
                  <td class="align-middle text-center">문의내용</td>
                  <td class="align-middle" colspan="3">
                      {{data.row.content}}
                  </td>
              </tr>
              <tr>
                  <td class="align-middle text-center">첨부파일</td>
                  <td class="align-middle" colspan="3">
                    <div class="custom-file">
                      <div style="width: max-content;position: relative;">
                        <a v-show="userAttachFiles.length>0" v-for="(item,idx) in userAttachFiles" class="popupImageItem" @click="downloadUserAttachFile(idx)" style="width:100%;padding-top:0;" target="_blank">{{item.name}}</a>
                      </div>
                    </div>
                  </td>
              </tr>
               <tr >
                  <td class="align-middle text-center">등록자</td>
                  <td class="align-middle">{{data.row.regId}}</td>
                  <td class="align-middle text-center">등록일시</td>
                  <td class="align-middle">{{data.row.regDt}}</td>
              </tr>
          </tbody>
        </table>
      </div>
      <div class="card-body" style="background-color:#fff;">
        <table class="table table-bordered table-hover">
          <colgroup>
              <col width="12%" class="bg-lightdark" />
              <col width="38%" />
              <col width="12%" class="bg-lightdark" />
              <col width="38%" />
          </colgroup>
          <tbody>
              <tr>
                  <td class="align-middle text-center">답변내용</td>
                  <td class="align-middle text-left" colspan="3">
                     <!-- <quill-editor
                        ref="myQuillEditor"
                        v-model="data.row.answer"
                        :style="'min-height:300px'"
                      />  -->
                      <jodit-editor
                        v-model="data.row.answer"
                        :config="jodit_config.config"
                        :buttons="jodit_config.buttons"
                        :plugins="jodit_config.plugins"
                        :style="'min-height:300px;'"
                      />
                  </td>
              </tr>
              <tr>
                <td class="align-middle text-center">첨부파일 1</td>
                <td class="align-middle" colspan="3">
                  <div class="custom-file">
                    <div v-show="fileCheck.file1 == null && uploadImageFile.file1 == null">
                      <input type="file" class="display-file" accept="image/*" id="file1" @change="insertFileName($event,'0')">
                      <label class="custom-file-label" for="file1">Choose a file...</label>
                    </div>
                    <div style="width: max-content;position: relative;">
                      <a class="popupImageItem" v-show="uploadImageFile.file1 != null" @click="downloadAs(0)" style="width:100%;padding-top:0" target="_blank">{{fileName.name1}}</a>
                      <span class="btn_remove" @click="fileRemove(fileCheck.file1.seq,0)" >X</span>
                    </div>
                  </div>
                </td>
              </tr>
              <!-- <tr>
                <td class="align-middle text-center">첨부파일 2</td>
                <td class="align-middle" colspan="3">
                  <div class="custom-file">
                    <div v-show="fileCheck.file2 == null && uploadImageFile.file2 == null">
                      <input type="file" class="display-file" accept="image/*" id="file2" @change="insertFileName($event,'1')">
                      <label class="custom-file-label" for="file2">Choose a file...</label>
                    </div>
                    <div style="width: max-content;position: relative;">
                      <a class="popupImageItem" v-show="uploadImageFile.file2 != null" @click="downloadAs(1)" style="width:100%;padding-top:0" target="_blank">{{fileName.name2}}</a>
                      <span class="btn_remove" @click="fileRemove(fileCheck.file2.seq,1)" >X</span>
                    </div>
                  </div>
                </td>
              </tr> -->
              <!-- <tr>
                <td class="align-middle text-center">첨부파일 3</td>
                <td class="align-middle" colspan="3">
                  <div class="custom-file">
                    <div v-show="fileCheck.file3 == null && uploadImageFile.file3 == null">
                      <input type="file" class="display-file" accept="image/*" id="file3" @change="insertFileName($event,'2')">
                      <label class="custom-file-label" for="file3">Choose a file...</label>
                    </div>
                    <div style="width: max-content;position: relative;">
                      <a class="popupImageItem" v-show="uploadImageFile.file3 != null" @click="downloadAs(2)" style="width:100%;padding-top:0" target="_blank">{{fileName.name3}}</a>
                      <span class="btn_remove" @click="fileRemove(fileCheck.file3.seq,2)" >X</span>
                    </div>
                  </div>
                </td>
              </tr> -->
              <tr>
                <td class="align-middle text-center">답변자ID</td>
                <td class="align-middle">{{data.row.answerAdminId}}</td>
                <td class="align-middle text-center">답변일시</td>
                <td class="align-middle">{{data.row.answerDt}}</td>
              </tr>
          </tbody>
        </table>
      </div>
      <div class="footer mt-2 mb-3">
        <div class="float-right">
            <b-button @click="remove()" class="btn btn-b btn-danger mr-2" variant="info mr-2">삭제</b-button>
            <b-button @click="search()" class="btn btn-b btn-outline-info mr-2" variant="outline-info mr-2">목록</b-button>
            <b-button @click="save()" class="btn btn-b btn-info mr-2" variant="info mr-2">저장</b-button>
        </div>
      </div>
    </div>
    <!-- // 목차/차시 -->
    <b-modal id="uploadModalFiles" size="s" title="개체연결" v-model="popupShowAddCat">
      <BoardCatList :catType="'04'"/>
    </b-modal>
  </ContentWrapper>
</template>
<script>
import Vue from 'vue'
import { reactive, ref, computed, onMounted, onUnmounted ,onBeforeMount} from '@vue/composition-api'
import {dataObject} from "@/utils/Constants";
import {getQNAList,getQNAItem,setQNAList,deleteQNAList,deleteQNAFile} from "@/api/notice/QnaListApi";
import {getBoardCatList,setBoardCatList, deleteBoardCatList} from "@/api/notice/BoardCatApi";
import {getSsoAdmList} from "@/api/sso/SsoAdmApi";
import Pagenation from "@/components/Common/Pagenation";
import {TableActionClass} from "@/utils/TableActionClass";
import SchDateRange from "../../components/Common/SchDateRange";
import SchText from "../../components/Common/SchText";
import ShowCounter from "../../components/Common/ShowCounter";
import Keyword from "../../components/Common/Keyword";
import BoardCatList from "../notice/component/BoardCatList";
import Datepicker from 'vuejs-datepicker'
import swal from 'sweetalert2'
import Axios from 'axios';
import moment from 'moment';

// 로딩처리
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

import draggable from 'vuedraggable'
// 목차/차시/파일

// import VueQuillEditor from 'vue-quill-editor'

// import 'quill/dist/quill.core.css' // import styles
// import 'quill/dist/quill.snow.css' // for snow theme
// import 'quill/dist/quill.bubble.css' // for bubble theme

// Vue.use(VueQuillEditor, /* { default global options } */)

// jodit Editor
import 'jodit/build/jodit.min.css'
import { JoditEditor } from 'jodit-vue'
import { jodit_config } from '@/components/Common/jodit_config'

export default {
  components: {SchDateRange, SchText, ShowCounter, Pagenation,  Loading, draggable, Keyword, Datepicker,BoardCatList, JoditEditor},

  setup(props, {root}){
    const selectedContSeq = '';

    const userAttachFiles = ref([]);

    const uploadImageFileValue = ref({
      file1 : '',
      file2 : '',
      file3 : '',
    });
    const uploadImageFile = ref({
      file1 : null,
      file2 : null,
      file3 : null,
    });
    const keywords = reactive({
      box : [],
      text : '',
    }); 

    const searchOptionsAll = ref([]);
    const searchOptions = ref([]);
    const searchOptionsAns = ref([{value:0,text:'전체'},{value:1,text:'답변 대기'},{value:2,text:'답변 완료'}]);
    const OptionsTextAll = ref('0');
    const OptionsText = ref('1');
    const OptionsTextAns = ref('0');
    const _dataObject = _.cloneDeep(dataObject);
    const data = reactive(_dataObject);

    const fileName = ref({
      name1 : '',
      name2 : '',
      name3 : '',
    });

    const fileCheck = ref({
      file1 : null,
      file2: null,
      file3: null,
    });

    const searchText = ref('');
    const searchValue = ref([]);
    const searchShowValue = ref([]);

    const popupShowAddCat = ref(false);

    const dataAns = ref();

    const Datedata = reactive({
      postDt: new Date(),
      postDtChk : false,
      endDt: new Date('9999-12-31'),
      endDtChk : false,
    })

    const loadData = async () => {
      let result = await getQNAList(data.params);
      data.list = result.data;
      data.count = result.data.length;
      root.$_localSort.set(data.list);

      searchValue.value = _.cloneDeep(data.list);
      OptionsText.value = '0'
      getBoardCatOption();
    }

    const getBoardCatOption = async() =>{
        searchOptionsAll.value = [];
        searchOptions.value = [];
        let result = await getBoardCatList('04');
        searchOptionsAll.value.push({
          value : 0,
          text  : '전체',
        });
        if(result.data){
          result.data.map((row,i) => {
            searchOptionsAll.value.push({
              value : row.seq,
              text  : row.categoryName,
            })
            searchOptions.value.push({
              value : row.seq,
              text  : row.categoryName,
            })
          });
        }
    }

    const keywordChange = (box,text,type) =>{
      if(type == "key"){
        keywords.box = box;
        keywords.text = text;
        data.row.keywords = '';
      }else{
        tags.box = box;
        tags.text = text;
        data.row.tags = '';
      }
    }

    const keywordRemove = ( box , text , type) =>{
      if(type == "key"){
         keywords.box = box;
         keywords.text = text;
      }
      else{
        tags.box = box;
        tags.text = text;
      }
    }


    const insertFileName = (e,count) =>{
       var input = e.target;
       let filename = '';
       let uploadfile = '';
       
       filename = input.files[0].name;
       switch(count){
         case '0' : 
           fileName.value.name1 = filename ;
           uploadImageFileValue.value.file1 = input.files[0] ;
         break;
         case '1' :
           fileName.value.name2 = filename ;
           uploadImageFileValue.value.file2 = input.files[0] ;
         break;
         case '2' :
           fileName.value.name3 = filename ;
           uploadImageFileValue.value.file3 = input.files[0] ;
         break;
         
       }
      
     if (input.files && input.files[0])
      { 
        var reader = new FileReader();
          reader.onload = (e) => {          
             uploadfile = e.target.result; 
             switch(count){
                case '0' : 
                  uploadImageFile.value.file1 = uploadfile ;
                  fileCheck.value.file1 = '';
                break;
                case '1' :
                  uploadImageFile.value.file2 = uploadfile ;
                  fileCheck.value.file2 = '';
                break;
                case '2' :
                  uploadImageFile.value.file3 = uploadfile ;
                  fileCheck.value.file3 = '';
                break;
              }
          }
          reader.readAsDataURL(input.files[0]);
      }
      
    }
    const saveDetail = () =>{
      data.params.mode = "detail";
      data.row = [];
      keywords.box = [];
      Keyword.text = '';
      OptionsText = 0;
      fileRemove(null,null);
    }
    
    const changeDate = (type) =>{
       let _temp = type == 'now' ? data.row.postDt : data.row.endDt;

       if(type == 'now'){
         if(Datedata.postDtChk == true){
           data.row.postDt = new Date();
           Datedata.postDt = _.cloneDeep(_temp);
         }
         else{
           data.row.postDt = Datedata.postDt;
         }
       }else{
         if(Datedata.endDtChk == true){
          data.row.endDt = new Date(9998,11,31);
          Datedata.endDt =  _.cloneDeep(_temp);
         }
         else{
           data.row.endDt = Datedata.endDt;
         }
       }
    }

    const ShowAnswer = ()=>{
        //답변 select 변경시 
    }

    const fileRemove = async(_seq,count)=>{
      if(_seq != null){
        if (!confirm("파일을 삭제 하시겠습니까?")) {
          return false;
        }
        else{
          switch(count){
            case 0 : 
              fileName.value.name1 =  null ;
              uploadImageFile.value.file1 =  null ;
              fileCheck.value.file1 = null;
            break;
            case 1 :
              fileName.value.name2 =  null ;
              uploadImageFile.value.file2 =  null ;
              fileCheck.value.file2 = null;
            break;
            case 2 :
              fileName.value.name3 =  null;
              uploadImageFile.value.file3 =  null ;
              fileCheck.value.file3 = null;
            break;
          }
          let params = {
            seq : _seq,
          }
          let result = await deleteQNAFile(params);
          if( result.data ){
            alert('파일이 삭제되었습니다.');
          }
        }
      }
        else{
          switch(count){
            case 0 : 
              fileName.value.name1 =  null ;
              uploadImageFile.value.file1 =  null ;
              fileCheck.value.file1 = null;
            break;
            case 1 :
              fileName.value.name2 =  null ;
              uploadImageFile.value.file2 =  null ;
              fileCheck.value.file2 = null;
            break;
            case 2 :
              fileName.value.name3 =  null;
              uploadImageFile.value.file3 =  null ;
              fileCheck.value.file3 = null;
            break;
            case null :
              fileName.value.name1 =  null ;
              uploadImageFile.value.file1 =  null ;
              fileCheck.value.file1 = null;
              fileName.value.name2 =  null ;
              uploadImageFile.value.file2 =  null ;
              fileCheck.value.file2 = null;
              fileName.value.name3 =  null;
              uploadImageFile.value.file3 =  null ;
              fileCheck.value.file3 = null;
            break;
          }
        }
    }

    const downloadAs = (num) => {
      const url = data.row.userBoardAttachList[num].url;
      const name = data.row.userBoardAttachList[num].name;
//        let fullUrl = aws_cdn_path + url;
      Axios.get(url, {
        headers: {
          "Content-Type": "application/octet-stream"
        },
        responseType: "blob"
      })
        .then(response => {
          const a = document.createElement("a");
          const url = window.URL.createObjectURL(response.data);
          a.href = url;
          a.download = name;
          a.click();
        })
        .catch(err => {
          console.log("error", err);
        });
    };

    const downloadUserAttachFile = (num) => {
      const url = userAttachFiles.value[num].url;
      const name = userAttachFiles.value[num].name;
      Axios.get(url, {
        headers: {
          "Content-Type": "application/octet-stream"
        },
        responseType: "blob"
      })
        .then(response => {
          const a = document.createElement("a");
          const url = window.URL.createObjectURL(response.data);
          a.href = url;
          a.download = name;
          a.click();
        })
        .catch(err => {
          console.log("error", err);
        });
    };

    onMounted(loadData)

    return{
      jodit_config,
      searchText,
      searchValue,
      searchShowValue,
      selectedContSeq,
      userAttachFiles,
      uploadImageFile,
      uploadImageFileValue,
      fileName,
      insertFileName,
      keywords,
      keywordChange,
      keywordRemove,
      searchOptions,
      searchOptionsAll,
      OptionsTextAll,
      OptionsText,
      dataObject,
      _dataObject,
      data,
      Datedata,
      saveDetail,
      popupShowAddCat,
      getBoardCatOption,
      changeDate,
      OptionsTextAns,
      searchOptionsAns,
      ShowAnswer,
      dataAns,
      fileRemove,
      downloadAs,
      downloadUserAttachFile,
      fileCheck,
      ...methods(),
      dataAction: new TableActionClass(data),
      localSort:root.$_localSort
    }
  },
}

function methods() {
  var context = {};
  context["getQNAList"] = getQNAList;
  context["setQNAList"] = setQNAList;
  context["deleteQNAList"] = deleteQNAList;
  context["deleteQNAFile"] = deleteQNAFile;
  context["getBoardCatList"] = getBoardCatList;
  context["getQNAItem"] = getQNAItem;

   // 목록
  async function search() {
    let _params = this.data.params

    // 목록으로 돌아갈 때 상세 데이터, 특히 에디터 내용을 초기화합니다.
    if (this.data.row) {
        this.data.row.answer = '';
    }

    this.dataAction.execute("getQNAList",context,_params);
    this.fileRemove(null,null);
  }

  // 상세
  async function edit(_seq){
    let _params = {
      seq: _seq
    }
    let noticeInfo = await this.dataAction.execute("getQNAItem",context, _params);

    // Jodit 에디터가 null 값을 제대로 처리하지 못하는 문제를 해결하기 위해
    // 불러온 데이터의 answer 값이 null이면 빈 문자열로 명시적으로 할당합니다.
    if (!this.data.row.answer) {
        this.data.row.answer = '';
    }

    this.OptionsText = noticeInfo.data.boardCatSeq;

    this.userAttachFiles = noticeInfo.data.userBoardAttachList.filter((item) => item.adminYn=='N');
    let adminAttachList = noticeInfo.data.userBoardAttachList.filter((item) => item.adminYn=='Y');

    this.setUserBoardAttachList(adminAttachList);
    this.fileCheck.file1 = adminAttachList[0] != null ? adminAttachList[0] : null ;
    this.fileCheck.file2 = adminAttachList[1] != null ? adminAttachList[1] : null ;
    this.fileCheck.file3 = adminAttachList[2] != null ? adminAttachList[2] : null ;
    this.settingKeywords(noticeInfo.data.keywords);
  }

  //파일첨부 데이터
  function setUserBoardAttachList(data){
    let _uploadImageFile = this.clearFileData();
    let _fileName = this.clearFileName();
    data.map((row,i)=>{
        switch(i){
          case 0 : 
            _uploadImageFile.file1 = row.url ;
            _fileName.name1 = row.name ;
          break;
          case 1 : 
            _uploadImageFile.file2 = row.url ;
            _fileName.name2 = row.name ;
          break;
          case 2 : 
            _uploadImageFile.file3 = row.url ;
            _fileName.name3 = row.name ;
          break;
        }
    });
  }

  function clearFileData(){
    let _uploadImageFile = this.uploadImageFile;
    return _uploadImageFile;
  }
  function clearFileName(){
    let _fileName = this.fileName;
    return _fileName;
  }



  //키워드 함수
  function settingKeywords(text){
    if(text != null){
      let _keywords = this.clearKeyword();
      _keywords.text = _.cloneDeep(text);
      _keywords.box = _.cloneDeep(text.split(","));
      if(_keywords.text.charAt(_keywords.text.length-1) == ',' ){  // 마지막 
          _keywords.box.map ((row , i)=>{
              if(row == ''){
                _keywords.box.splice(i,1);
              }
          });
      }
      text = '';
    }
  } 

  function clearKeyword(){
    let _keywords = this.keywords;
    _keywords.box = [];
    _keywords.text = '';
    return _keywords;
  }

   // 저장
  async function save() { 
    if (!confirm("내용을 저장 하시겠습니까?")) {
        // 취소(아니오) 버튼 클릭 시 이벤트
        return false;
    } else {
       var formData = new FormData();
       formData.append("seq", this.data.row.seq);
       formData.append("answer", this.data.row.answer);
       formData.append("mfileOne", this.uploadImageFileValue.file1);
       formData.append("mfileTwo", this.uploadImageFileValue.file2);
       formData.append("mfileThree", this.uploadImageFileValue.file3);

      let result = await setQNAList(formData).then((result) => {
          if(result.data){
            alert('저장 완료되었습니다.');
            let _params = this.data.params;
            this.dataAction.execute("getQNAList",context,_params);
          }
        });
    }
  }
  async function remove() { 
    if (!confirm("내용을 삭제 하시겠습니까?")) {
        // 취소(아니오) 버튼 클릭 시 이벤트
        return false;
    } else {
      let params;
      if(this.data.row.seq !=null){
        params = {
          seq : this.data.row.seq,
        }
      }
      let result = await deleteQNAList(params);
      if( result.data ){
        alert('삭제되었습니다.');
        let _params = this.data.params;
        this.dataAction.execute("getQNAList",context,_params);
      }
    }
  }

  // 초기화
  async function reset(){
    this.data.params.mode="list";
  }

  async function saveUploadlist(item,type) {
    if(type =='excel'){
        await saveCsContExcel(item.params);
    }
    else{
      await saveCsCont(item.params);
    }
    if( item.version == 'unit'){
      this.getAtrbListExcel(item.delete_param.contSeq, '202004' , item.atrbInfo , null);
    }
    else{
      //this.getAtrbListExcel(item.delete_param.contSeq, '202004' , item.atrbInfo);
      this.getDepth3Excel(item.delete_param.contSeq , item.atrbInfo , item.params);
    }
  }


  return {
    search,
    edit,
    reset,
    save,
    remove,
    clearKeyword,
    clearFileData,
    clearFileName,
    saveUploadlist,
    settingKeywords,
    setUserBoardAttachList,
    }
}

</script>
